@switch(type){ @case('fill'){
<div
  class="tw-my-1 tw-px-6 tw-border tw-border-gray-100 dark:tw-border-dark-100 tw-bg-white dark:tw-bg-dark-300 tw-rounded-md tw-relative tw-flex-between"
  [class]="spacingClasses"
>
  <div class="tw-flex-center">
    <ng-content select="[icon]"></ng-content>
    <ng-content select="[img]"></ng-content>

    <span class="tw-font-medium tw-whitespace-nowrap" [class]="labelClass">
      {{ label | translate }}
    </span>
    <small
      *ngIf="hasCurrency"
      class="tw-font-medium tw-mx-1 tw-text-gray-600 dark:tw-text-gray-300"
    >
      {{ "common.currencyWithParentheses" | translate }}
    </small>

    <ng-content select="[currency]"></ng-content>
  </div>

  <ng-content select="[content]"></ng-content>

  <ng-container *ngIf="isShowValue">
    <span
      copyToClipboard
      class="badge badge-light border tw-text-gray-800 tw-text-[13px] tw-whitespace-nowrap !tw-overflow-auto tw-min-w-10 tw-mr-2 tw-max-w-[80%] list-group-item-value"
      [class]="getValueClassNames()"
      *ngIf="!numberSeparator"
      [innerHTML]="value | checkValue"
      [ngClass]="
        appStateService.currentAppLang() == 'fa' ? 'dir-rtl' : 'dir-ltr'
      "
    ></span>
    <span
      copyToClipboard
      class="badge badge-light border tw-text-gray-800 tw-text-[13px] tw-whitespace-nowrap !tw-overflow-auto tw-min-w-10 tw-mr-2 tw-max-w-[80%] list-group-item-value"
      [class]="getValueClassNames()"
      *ngIf="numberSeparator"
      [innerHTML]="value | numberSeparator | checkValue"
      [ngClass]="
        appStateService.currentAppLang() == 'fa' ? 'dir-rtl' : 'dir-ltr'
      "
    ></span>
  </ng-container>
</div>
} @case('outline'){
<div class="tw-w-full">
  <div
    class="my-3 tw-min-h-[56px] tw-rounded-md tw-border-[#9e9e9e] dark:tw-border-[#74747d] tw-border tw-flex-center tw-font-medium tw-mb-3 tw-relative"
  >
    <span
      class="tw-text-sm tw-absolute tw-bg-white dark:tw-bg-dark-500 tw-font-normal tw-px-3 tw-py-1 tw-right-[20px] tw-text-[#707983] dark:tw-text-[#667492] tw-top-[-12px]"
    >
      {{ label | translate }}
    </span>
    <div
      class="text-center dark:tw-text-gray-200 tw-p-4"
      [innerHTML]="value | checkValue"
      copyToClipboard
    ></div>
  </div>
</div>
} }
